/**
 * @generated SignedSource<<280898479f9676f8213072290703d15b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionScoringCriteriaFragment$data = {
  readonly event: {
    readonly event: {
      readonly slug: string;
    };
  };
  readonly id: string;
  readonly slug: string;
  readonly stage: {
    readonly scoringCriteria: ReadonlyArray<{
      readonly description: string | null | undefined;
      readonly id: string;
      readonly title: string;
      readonly weight: number;
    }>;
    readonly seq: number;
    readonly viewerCanEdit: boolean;
  } | null | undefined;
  readonly " $fragmentType": "CompetitionScoringCriteriaFragment";
};
export type CompetitionScoringCriteriaFragment$key = {
  readonly " $data"?: CompetitionScoringCriteriaFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionScoringCriteriaFragment">;
};

import CompetitionScoringCriteriaFragmentQuery_graphql from './CompetitionScoringCriteriaFragmentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "owner"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "stage"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": CompetitionScoringCriteriaFragmentQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "CompetitionScoringCriteriaFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "slug",
          "variableName": "owner"
        }
      ],
      "concreteType": "EventCompetition",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "event",
          "plural": false,
          "selections": [
            (v0/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "stage",
          "variableName": "stage"
        }
      ],
      "concreteType": "CompetitionStage",
      "kind": "LinkedField",
      "name": "stage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "seq",
          "storageKey": null
        },
        {
          "alias": "viewerCanEdit",
          "args": [
            {
              "kind": "Literal",
              "name": "action",
              "value": "UPDATE_COMPETITION_STAGE"
            }
          ],
          "kind": "ScalarField",
          "name": "viewerCan",
          "storageKey": "viewerCan(action:\"UPDATE_COMPETITION_STAGE\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionScoringCriterion",
          "kind": "LinkedField",
          "name": "scoringCriteria",
          "plural": true,
          "selections": [
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "weight",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*:: as any*/)
  ],
  "type": "Competition",
  "abstractKey": null
};
})();

(node as any).hash = "fabbf8fb7fe48f98b19ec1bf0958627b";

export default node;
